module.exports = "dist/ecdd509cadbf1ea78b8d2e31ec52328c.eot";


//////////////////
// WEBPACK FOOTER
// ./~/materialize-css/fonts/roboto/Roboto-Bold.eot
// module id = 219
// module chunks = 0